import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../../../common/constants/dsClasses';
import { confirmOrderMsg, nextMsg, previousMsg, t } from '../../../../common/i18n';

import './CheckoutFooterCoCo.scss';

export interface CheckoutFooterProps {
  onNext?: () => void;
  onPrevious?: () => void;
  onSubmit?: () => void;
  disableForward?: boolean;
}

export const CheckoutFooterCoCo = ({ onNext, onPrevious, onSubmit, disableForward = false }: CheckoutFooterProps) => {
  return (
    <footer className="of-footer-buttons__footer" aria-label="Checkout actions">
      <div
        className={classNames(
          dsClass.MARGIN_TOP_4,
          dsClass.MARGIN_BOTTOM_4,
          dsClass.DISPLAY_FLEX,
          dsClass.JUSTIFY_CONTENT_SPACE_BETWEEN,
          dsClass.ALIGN_ITEMS_CENTER
        )}
      >
        {onPrevious && (
          <CL.Button
            onClick={onPrevious}
            iconPosition="left"
            icon={<CL.Icon icon="arrow-left" type="filled" className="of-footer-buttons__icon--left" />}
            color="link"
            className="of-footer-buttons__button--left"
          >
            {t.CACI(previousMsg)}
          </CL.Button>
        )}
        {onNext && (
          <CL.Button
            onClick={onNext}
            iconPosition="right"
            icon={<CL.Icon icon="arrow-right" type="filled" className="of-footer-buttons__icon--right" />}
            className="of-footer-buttons__button--right"
            disabled={disableForward}
          >
            {t.F0MY(nextMsg)}
          </CL.Button>
        )}
        {onSubmit && (
          <CL.Button
            onClick={onSubmit}
            iconPosition="right"
            icon={<CL.Icon icon="arrow-right" type="filled" className="of-footer-buttons__icon--right" />}
            className="of-footer-buttons__button--right"
            disabled={disableForward}
          >
            {t.RZU4(confirmOrderMsg)}
          </CL.Button>
        )}
      </div>
    </footer>
  );
};
